import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../reducers/root.reducer';

// App Root State Selectors
export const getRootState = createFeatureSelector<fromRoot.RootState>('root');

export const getAuthToken = createSelector(
  getRootState,
  (state) => state?.authToken
);

export const getRootUserType = createSelector(
  getRootState,
  (state) => state?.userType
);
